// extracted by mini-css-extract-plugin
module.exports = {"container":"_3AckhKhgG2qJzKCHUPPOPO","newAdditionalDishFields":"_2i_og0SPNudlu_2Hhd1RTi"};